import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SelfService } from '../self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.css']
})
export class SiteComponent implements OnInit {

  @ViewChild("myckeditor", { static: false }) ckeditor: any;
  @ViewChild('myInput', { static: true }) myInputVariable: ElementRef;
  landingDto: any;
  landingData: any;
  siteData: any[] = [];
  siteContacts: any[] = [];
  siteId: string;
  siteName: string = null;
  siteDesc: string = null;
  siteVision: string = null;
  siteMission: string = null;
  siteBanner: string = null;
  locationCode: string = null;
  editandSavebtn = false;
  savebtn = false;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string = this.loginData.userId;
  siteBannerImage: string = null;
  isExistSitename: boolean;
  isExistLocationCode: boolean;
  isSiteContactsChecked: boolean;
  alertSuccess: boolean;
  updateMessage: boolean;
  uploadFileExtension: boolean;
  userList = [];
  uploadFileName: string = null;
  lbl: any;
  imagePath: any[];
  removeToolbar: any = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' };
  width: number;
  height: number;
  visionLength: boolean;
  missionLength: boolean;
  siteNameCheck: boolean;
  locationCodeCheck: boolean;
  siteDescCheck: boolean;
  siteBannerUploadCheck: boolean;
  visionBlankCheck: boolean;
  siteNameCheckOnEdit = "";
  tableShow: boolean;
  noDataFound: boolean;
  numberOfElements: number;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  tableresp: boolean;
  errorMessage = "";
  errorMessageActive: boolean;
  timeOutError: boolean;
  method: string;
  param: string;
  msg1: string;
  showReset = false;
  values: any = []
  isLocationCodeUnique: boolean;
  firstEdit = false;
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  isUploadImage = false;
  uploadImageDone = false;
  isLoaderStop = false;

  //Image Cropper
  imageChangedEvent: any = '';
  croppedImage: any = '';
  siteLatitude : any = 0;
  siteLongitude : any = 0;
  countryName = 'Others';
  dataToggleConstant = 'data-toggle';
  dataTargetConstant = 'data-target';
  constructor(private readonly siteService: SelfService,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly router: Router,
    private readonly environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    if (this.adminId !== '1') {
      this.router.navigate(['/site-home']);
    }

    this.spinnerService.show();
    this.logUserAction();
    window.onload = function () {
      setTimeout(function () {
        scrollTo(0, 0);
      });
    }

    this.savebtn = true;
    this.siteId = '0';

    this.landingData = {
      "filter": { "siteId": this.siteId },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": ConstantValues.pageLimit,
      "sortDirection": "ASC",
      "sortProperty": "siteName",
      "uid": ""
    }
    this.spinnerService.show();
    this.listSite();

    //list primary contact only super admin id=1
    this.landingDto = {
      "filter": { "adminId": 1 },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }

    this.siteService.getUserDropDown(this.landingDto).subscribe(data => {
      this.userList = data;
    })

    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }
    setTimeout(function () {
      this.spinnerService.hide();
    }.bind(this), 2000);

    this.cancelUploadedImage();
  }

  public toggleCheckboxBpg(event, user) {
    if (event.target.checked) {
      user.checked = true
      this.siteContacts.push(user);
    } else {
      user.checked = false
      const index: number = this.siteContacts.indexOf(user);
      if (index !== -1) {
        this.siteContacts.splice(index, 1);
      }
    }
  }

  /** For submitting Site data
   * @method onSubmit
   */
  public onSubmit() {
    this.clearAlerts();

    this.siteName = this.siteName.trim();

    if (this.siteName === "") {
      this.clearAlerts();
      this.siteNameCheck = true;
      this.removeModal();
      return;
    }




    if (this.siteDesc.trim() === "") {
      this.clearAlerts();
      this.siteDescCheck = true;
      this.removeModal();
      return;
    }

    this.values = this.locationCode.split(',');
    for (const val of this.values) {
      if (val.length !== 6 && val.length !== 4 ) {
        this.locationCodeCheck = true;
        this.removeModal();
        return;
      }

    }


    for (let i = 0; i <= this.values.length; i++) {
      for (let j = i; j <= this.values.length; j++) {
        if (i !== j && this.values[i] === this.values[j]) {
          this.isLocationCodeUnique = true;
          this.removeModal();
          return;
        }
      }
    }


    if (this.uploadFileExtension === true) {
      this.clearAlerts();
      this.uploadFileExtension = true;
      this.removeModal();
      return;
    }

    if (this.siteVision.trim().length === 0) {
      this.clearAlerts();
      this.visionBlankCheck = true;
      this.removeModal();
      return;
    }

    if (this.siteMission.trim().length === 0) {
      this.clearAlerts();
      this.visionBlankCheck = true;
      this.removeModal();
      return;
    }

    if (this.siteVision.length > 3000) {
      this.clearAlerts();
      this.visionLength = true;
      this.removeModal();
      return;
    }

    if (this.siteMission.length > 3000) {
      this.clearAlerts();
      this.visionLength = true;
      this.removeModal();
      return;
    }

    if (this.siteContacts.length === 0 && this.locationCode !== 'DFLT') {
      this.clearAlerts();

      this.isSiteContactsChecked = true;
      this.removeModal();
      return;
    }




    if (this.savebtn === true) {
      this.setModal();
      this.popupModal();
      document.getElementById('siteSubmit').click();
    }
    if (this.editandSavebtn === true) {
      this.setModal();
      this.popupModal();
      document.getElementById('siteEditSubmit').click();
    }
  }
  popupModal() {
    if (this.editandSavebtn === true) {

      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to update ? ";
    }
    else {
      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to save ? ";
    }
  }
  setModal() {
    if (this.editandSavebtn === true) {
      document.getElementById('siteEditSubmit').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('siteEditSubmit').setAttribute(this.dataTargetConstant, '#myModal');

    } else {
      document.getElementById('siteSubmit').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('siteSubmit').setAttribute(this.dataTargetConstant, '#myModal');
    }
  }
  removeModal() {
    if (this.editandSavebtn === true) {
      document.getElementById('siteEditSubmit').removeAttribute(this.dataToggleConstant);
      document.getElementById('siteEditSubmit').removeAttribute(this.dataTargetConstant);
    } else {
      document.getElementById('siteSubmit').removeAttribute(this.dataToggleConstant);
      document.getElementById('siteSubmit').removeAttribute(this.dataTargetConstant);
    }
  }
  /** For editing the site detail
    * @method editSite
    */
  editSite(data) {
    this.showReset = true;
    this.lbl = document.getElementById('filename');
    this.uploadFileName = data.siteBanner;
    if (this.uploadFileName != null && this.uploadFileName !== undefined && this.uploadFileName.trim() !== "") {
      const b = this.uploadFileName.split('/');
      this.lbl.innerText = b[1];
    }
    this.siteName = data.siteName;
    this.siteNameCheckOnEdit = data.siteName;
    this.locationCode = data.locationCode;
    this.siteDesc = data.siteDesc;
    this.siteId = data.siteId;
    this.siteVision = data.siteVision;
    this.siteMission = data.siteMission;
    this.siteBannerImage = '';
    this.siteContacts = [];
    this.editandSavebtn = true;
    this.savebtn = false;
    this.siteLatitude  = data.siteLatitude;
    this.siteLongitude = data.siteLongitude;
    this.countryName = data.countryName;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    for (const user of this.userList) {
      user.checked = false;
    }

    for (const user1 of this.userList) {
      if (data.sitePrimaryContact != null) {
        for (const dat of data.sitePrimaryContact) {
          if (user1.userId === dat.userId) {
            user1.checked = true;
            this.siteContacts.push(user1);
          }

        }
      }
    }
  }

  edit(data, i) {
    this.uploadFileExtension = false;
    this.clearAlerts();
    if (this.siteName != null || this.siteDesc != null || this.locationCode != null || this.siteBanner != null) {
      this.firstEdit = true;
    }

    if (this.firstEdit === false) {
      this.firstEdit = true;
      this.editSite(data);
    } else {
      document.getElementById('edit' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('edit' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editSite";
      this.param = data;
      this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }

  resetSite() {
    this.clearAlerts();
    this.method = "onResetClick";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  onResetClick() {
    this.uploadFileExtension = false;
    this.siteName = null;
    this.siteDesc = null;
    this.siteId = '0';
    this.siteVision = '';
    this.siteMission = '';
    this.siteBanner = null;
    this.siteBannerImage = null;
    this.editandSavebtn = false;
    this.savebtn = true;
    this.locationCode = null;
    this.searchKey = null;
    this.landingData.searchTerm = null;
    this.listSite();
    this.siteLongitude = 0;
    this.siteLatitude = 0;
    this.countryName = 'Others'
    for (let i = 0; i < this.siteData.length; i++) {
      document.getElementById('edit' + i).removeAttribute(this.dataToggleConstant);
      document.getElementById('edit' + i).removeAttribute(this.dataTargetConstant);
    }
    this.firstEdit = false;

    for (const use of this.userList) {
       use.checked = false;
    }
    this.siteContacts = [];
    if (this.lbl !== undefined) {
      this.lbl.innerText = "JPEG or PNG (1366 x 400)";
    }
    document.getElementById("base64textarea").textContent = '';
    this.cancelUploadedImage();
  }
  /** For listing the site detail
     * @method listSite
     */
  listSite() {
    this.timeOutError = false;
    this.siteService.getAllSiteList(this.landingData).subscribe(data => {
      this.siteData = data.content;
      this.tableShow = true;
      this.numberOfElements = data.totalElements;
      if (this.siteData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
        setTimeout(function () {
          this.spinnerService.hide();
        }.bind(this), 5000);
      }

    }, err => {
      if (err.value.statusText === ConstantValues.unknownError) {
        this.spinnerService.hide();
        this.timeOutError = true;
      }
    })
  }

  /** For filtering data by current page
     * @class SiteComponent
     * @method pageChanged
     * @params event
     */
  pageChanged(event) {
    this.clearAlerts();
    this.landingData.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listSite();
  }

  /** For sorting the table through columns
   * @class SiteComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearAlerts();
    if (this.landingData.sortDirection === "ASC") {
      this.landingData.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingData.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.landingData.sortProperty = sortingby;
    this.listSite();
  }

  /** For searching the table through keywords
  * @class SiteComponent
  * @method searchMe
  */
  searchMe() {
    this.clearAlerts();
    this.spinnerService.show();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.landingData.page = 0;
    this.landingData.searchTerm = this.searchKey;
    this.listSite();
    this.currentPage = 1;
    this.spinnerService.hide();
  }

  /** For deleting the site detail
     * @method deleteSite
     */
  deleteSite(data) {
    this.timeOutError = false;
    this.siteService.deleteSite(data.siteId).subscribe(_data => {
      this.listSite();
    }, err => {
      if (err.value.statusText === ConstantValues.unknownError) {
        this.spinnerService.hide();
        this.timeOutError = true;
      }
    })
  }

  onSiteBannerSelected(event) {
    const files = event.target.files;
    const file = files[0];
    this.uploadFileName = file.name;
    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      this.uploadFileExtension = true;
    } else {
      this.uploadFileExtension = false;
    }
    const image: any = event.target.files[0];
    const fr: any = new FileReader();
    fr.onload = () => { // when file has loaded
      const img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (this.width < 1366) {
          this.uploadFileExtension = true;
        } else {
          this.uploadFileExtension = false;
        }
      };
      img.src = fr.result; // This is the data URL

    };
    fr.readAsDataURL(image);



    this.lbl = document.getElementById('filename');
    this.lbl.innerText = this.uploadFileName;
    if (files && file) {
      this.siteBannerImage = "";
      let imageData: any = '';
      const reader: any = new FileReader();
      if (reader.readAsBinaryString) {
        reader.onloadend = function (readerEvt) {
          const binaryString = readerEvt.target.result;
          imageData = btoa(binaryString);
          document.getElementById("base64textarea").textContent = imageData;
        };
        this.siteBannerImage = imageData;
        reader.readAsBinaryString(file);
      } else { //IE 10 or 11
        let binary = "";
        reader.onload = function (e) {
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          //binary - readonly so assign content to another property
          imageData = btoa(binary);
          document.getElementById("base64textarea").textContent = imageData;
        }
        this.siteBannerImage = imageData;
        reader.readAsArrayBuffer(file);
      }
    }
  }

  /** For submitting Site data
   * @method onSubmit
   */
  public save() {
    this.timeOutError = false;
    this.values = this.locationCode.split(',');
    for (const val of this.values) {
      if (val.length !== 6 &&val.length !== 4 ) {
        this.locationCodeCheck = true;
        this.removeModal();
        return;
      }
    }
    for (let i = 0; i <= this.values.length; i++) {
      for (let j = i; j <= this.values.length; j++) {
        if (i !== j && this.values[i] === this.values[j]) {
          this.isLocationCodeUnique = true;
          this.removeModal();
          return;
        }
      }
    }


    this.spinnerService.show();

    this.siteBannerImage = document.getElementById("base64textarea").textContent;

    if (this.siteBannerImage.length === 0) {
      this.siteBannerImage = null;
    }
    const data = {
      "siteMasterDTO": {
        "createdBy": this.loginUserId,
        "isActive": true,
        "modifiedBy": this.loginUserId,
        "siteBanner": this.uploadFileName,
        "siteDesc": this.siteDesc,
        "siteId": this.siteId,
        "siteMission": this.siteMission,
        "siteName": this.siteName,
        "siteVision": this.siteVision,
        "locationCode": this.locationCode,
        "siteLatitude" : this.siteLatitude,
        "siteLongitude" : this.siteLongitude,
        "countryName" : this.countryName
      },
      "sitePrimaryContactDTO": [

      ],
      "siteBannerImage": this.siteBannerImage,
      "editAndSave": this.editandSavebtn
    }

    for (const siteContact of this.siteContacts) {
      if (status === 'save') {
        siteContact.sitePrimaryContactId = 0;
      }
      data.sitePrimaryContactDTO.push({
        "createdBy": this.loginUserId,
        "isActive": true,
        "siteId": this.siteId,
        "sitePrimaryContactId": siteContact.sitePrimaryContactId,
        "userId": siteContact.userId
      })
    }
    this.siteService.saveAllSite(data).subscribe(data => {
      if (data.body != null && data.body.message !== undefined) {
        this.bpgCommonService.isSiteOrBpgCreated.next(true);
        this.spinnerService.hide();
        this.errorMessage = data.body.message;
        this.errorMessageActive = true;
      }
      else if (data.message) {
        this.errorMessage = data.message;
        this.errorMessageActive = true;
        this.spinnerService.hide();
      }
      else if (this.editandSavebtn === true) {
        this.clearAlerts();
        this.updateMessage = true;
        this.spinnerService.hide();
      } else {
        this.bpgCommonService.isSiteOrBpgCreated.next(true);
        this.alertSuccess = true;
        this.spinnerService.hide();
      }
      if (data != null || data !== undefined) {
        this.siteId = data.body.siteMasterDTO.siteId;
      }
      this.listSite();
      this.editandSavebtn = true;
      this.savebtn = false;

    }, err => {
      if (err.value.statusText === ConstantValues.unknownError) {
        this.spinnerService.hide();
        this.timeOutError = true;
      }

    })
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 500);

  }

  //to clear all the alert messages
  clearAlerts() {
    this.isSiteContactsChecked = false;
    this.errorMessageActive = false;
    this.alertSuccess = false;
    this.siteNameCheck = false;
    this.siteDescCheck = false;
    this.isExistSitename = false;
    this.visionLength = false;
    this.visionBlankCheck = false;
    this.locationCodeCheck = false;
    this.updateMessage = false;
    this.missionLength = false;
    this.isLocationCodeUnique = false;
    this.errorMessageActive = false;
    this.removeModal();
  }

  fileChangeEvent(event: any): void {
    const files = event.target.files;
    const file = files[0];
    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      this.uploadFileExtension = true;
      this.myInputVariable.nativeElement.value = '';
    } else {
      this.uploadFileExtension = false;
      this.isLoaderStop = false;
      this.imageChangedEvent = event;
      this.uploadFileName = file.name;
      document.getElementById("filename").textContent = this.uploadFileName;
      this.isUploadImage = true;
      this.uploadImageDone = true;
    }

  }
  imageCropped(event: ImageCroppedEvent) {
    this.uploadImageDone = true;
    this.croppedImage = event.base64;
    document.getElementById("base64textarea").textContent = this.croppedImage.replace(/^data:image\/[a-z]+;base64,/, "");
    this.siteBannerImage = document.getElementById("base64textarea").textContent;
  }
  imageLoaded() {
    this.isLoaderStop = true;
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cancelUploadedImage() {
    document.getElementById("base64textarea").textContent = '';
    document.getElementById("filename").textContent = "JPEG or PNG";
    this.isUploadImage = false;
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.siteBannerImage = '';
    this.uploadFileName = '';
    this.isLoaderStop = false;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.myInputVariable.nativeElement.value = '';
    this.uploadFileExtension = false;
  }

  doneUploadedImage() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.isUploadImage = false;
    this.uploadImageDone = false;
    this.isLoaderStop = false;
    this.myInputVariable.nativeElement.value = '';
    this.uploadFileExtension = false;
  }

  logUserAction() {
    const data = {
      userId : this.loginUserId,
      categoryDescription : "SelfServices - Site Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }

}
